import { cn } from '@neo/lib/utils'
import { Workflow } from 'lucide-react'
import { FlowNodeIconClass } from '../../config/panel.config'
import { FlowNodeTypes } from '../../types'

interface NodeNameProps {
  name: string
  type?: FlowNodeTypes | null
  className?: string
}

export const NodeName = ({ name, type, className }: NodeNameProps) => {
  const nodeConfig = type ? FlowNodeIconClass[type] : null
  const isStartNode = type === FlowNodeTypes.start
  const startIcon = isStartNode ? <Workflow size={16} className="text-primary" /> : null

  return (
    <div className="flex min-w-0 items-center gap-2">
      {nodeConfig && (
        <div
          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded ${isStartNode ? 'bg-primary/10' : nodeConfig.class}`}
        >
          {startIcon || nodeConfig.icon}
        </div>
      )}
      <span className={cn('font-inter text-s-400 min-w-0 break-words', className)}>{name}</span>
    </div>
  )
}
